export default "__VITE_ASSET__CNhPpL0J__"